import type { JSX } from 'react'

export const MaximizeIcon = (): JSX.Element => (
  <use href='#maximizeIcon' height='100%' width='100%' />
)
